import { render } from "./StudentDiscountDetailView.vue?vue&type=template&id=23cdf843&scoped=true"
import script from "./StudentDiscountDetailView.vue?vue&type=script&lang=js"
export * from "./StudentDiscountDetailView.vue?vue&type=script&lang=js"

import "./StudentDiscountDetailView.vue?vue&type=style&index=0&id=23cdf843&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cdf843"]])

export default __exports__